/*
 *  MENU ACCESSIBLE ----------------------------------------------------------------------------------------------------------
 */
// Définition des variables
var mainElement, parentElement, currentElement,
    classMenu = "main-menu",
    classHasChildren = "menu-item-has-children",
    classHover = "mhover";

// Fonction du menu Accessible
$.fn.menuAccessible = function () {
    var menu = $(this);

    // Gestion du focus au clavier : Tab & Shift+Tab
    $("."+classMenu+" [itemprop='url']").focus( function() {

        // Stocke l'element courant
        currentElement = $(this).parent();

        // Stocke le menu de 1er niveau
        mainElement = currentElement.parents('li').last();
        if ( typeof(mainElement.attr("id")) === 'undefined' ) {
            mainElement = currentElement;
        }

        // On supprime le classHover sur tous les enfants
        $("."+classMenu).find("li").removeClass(classHover);

        // N'ajoute la classHover que si l'element a des enfants
        if ( currentElement.hasClass(classHasChildren) ) {
            currentElement.addClass(classHover);
        }
        // Ajoute la classHover a tous les parents
        currentElement.parents("li").addClass(classHover);

    });

    // Gestion des fleches de direction pour sauter les sous-menus
    $(menu).keydown(function(e){
        switch (e.keyCode) {
            // Flèche droite
            case 39 :
                e.preventDefault();
                // Supprime la classHover a tous les parents
                currentElement.parents("li").removeClass(classHover);
                // Passe au menu de 1er niveau suivant
                mainElement.next().children("a").focus();
                break;

            // Flèche gauche
            case 37 :
                e.preventDefault();
                // Supprime la classHover a tous les parents
                currentElement.parents("li").removeClass(classHover);
                // Passe au menu de 1er niveau precedent
                mainElement.prev().children("a").focus();
                break;

            // Shift + Tab
            case 9 :
                if ( e.shiftKey ) {
                    // Passe au menu precedent du meme niveau
                    // sinon si first-child, on conserve la navigation clavier classique
                    if ( !currentElement.is(":first-child") ) {
                        e.preventDefault();
                        currentElement.prev().children("a").focus();
                    }
                }
                break;
        }
    });

    // Desactivation de tous les focus au survol de la souris
    $(menu).mouseenter(function() {
        $(":focus").blur();
        $("."+classMenu).find("li").removeClass(classHover);
    });
};

// Initialisation du menu accessible
$("."+classMenu).menuAccessible();
